import { ObjectUtils } from '@mm/utils';
import ButtonModel, { ButtonType } from '../model/ButtonModel';
import { IceBreakerModel } from '../model/IceBreakerModel';
import WidgetModel from '../model/WidgetModel';

// WidgetModel mutation functions that were extracted
// from WidgetModel

const hasEntries = (widget: WidgetModel) => {
  if (widget && widget.config) {
    return Boolean(widget.config.entries);
  }
};

const getButton = (widget: WidgetModel | IceBreakerModel, buttonId: number) => {
  const index = widget.buttons.findIndex(b => b.id === buttonId);

  return index === -1 ? null : widget.buttons[index];
};

const updateButton = (
  widget: WidgetModel | IceBreakerModel,
  button: ButtonModel,
): boolean => {
  const buttonIndex = widget.buttons.findIndex(b => b.id === button.id);

  if (buttonIndex === -1) return false;

  widget.buttons[buttonIndex] = button;
  return true;
};

const deleteButton = (
  widget: WidgetModel | IceBreakerModel,
  buttonId: number,
) => {
  const buttonIndex = widget.buttons.findIndex(b => b.id === buttonId);

  if (buttonIndex === -1) return false;

  widget.buttons.splice(buttonIndex, 1);
  return true;
};

const getEntry = (widget: WidgetModel, entryId: number) => {
  if (!hasEntries(widget)) return null;

  if (widget && widget.config && widget.config.entries) {
    const entry = widget.config.entries.find(e => e.id === entryId);
    return entry || null;
  }
};

const updateEntry = (widget: WidgetModel, entry) => {
  if (!hasEntries(widget)) return false;

  if (widget && widget.config && widget.config.entries) {
    const entryIndex = widget.config.entries.findIndex(e => e.id === entry.id);

    if (entryIndex === -1) return false;

    widget.config.entries[entryIndex] = entry;
    return true;
  }
};

const deleteEntry = (widget: WidgetModel, entryId: number) => {
  if (!hasEntries(widget)) return false;

  if (widget && widget.config && widget.config.entries) {
    const entryIndex = widget.config.entries.findIndex(e => e.id === entryId);

    if (entryIndex === -1) return false;

    widget.config.entries.splice(entryIndex, 1);
    return true;
  }
};

const getEntryButton = (
  widget: WidgetModel,
  entryId: number,
  buttonId: number,
) => {
  if (!hasEntries(widget)) return null;

  if (widget && widget.config && widget.config.entries) {
    const entry = widget.config.entries.find(e => e.id === entryId);

    if (!entry) return null;

    const button = entry.buttons.find(b => b.id === buttonId);

    return button || null;
  }
};

const updateEntryButton = (
  widget: WidgetModel,
  entryId: number,
  button: ButtonModel,
) => {
  if (!hasEntries(widget)) return false;

  if (widget && widget.config && widget.config.entries) {
    const entryIndex = widget.config.entries.findIndex(e => e.id === entryId);

    if (entryIndex === -1) return false;

    const entry = widget.config.entries[entryIndex];
    const buttonIndex = entry.buttons.findIndex(b => b.id === button.id);

    if (buttonIndex === -1) return false;

    entry.buttons[buttonIndex] = button;
    return true;
  }
};

const deleteEntryButton = (
  widget: WidgetModel,
  entryId: number,
  buttonId: number,
) => {
  if (!hasEntries(widget)) return false;

  if (widget && widget.config && widget.config.entries) {
    const entryIndex = widget.config.entries.findIndex(e => e.id === entryId);

    if (entryIndex === -1) return false;

    const entry = widget.config.entries[entryIndex];
    const buttonIndex = entry.buttons.findIndex(b => b.id === buttonId);

    if (buttonIndex === -1) return false;

    entry.buttons.splice(buttonIndex, 1);
    return true;
  }
};

const removeButtonPageHiddenIfInvalid = (button: ButtonModel) => {
  if (button && button.type !== ButtonType.PAGE) {
    ObjectUtils.removeProperty('pageHidden', button.config);
  }
};

const WidgetModelHelpers = {
  getButton,
  updateButton,
  deleteButton,
  getEntry,
  updateEntry,
  deleteEntry,
  getEntryButton,
  updateEntryButton,
  deleteEntryButton,
  removeButtonPageHiddenIfInvalid,
};

export default WidgetModelHelpers;
